// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-width: 400px) {\n.v-dialog.alert-dialog {\n    margin: 5px !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
